import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseCrudService } from '../crud/crud.service';
import { ICmsValueBox } from '../../models/cmsValueBox';

@Injectable({
  providedIn: 'root'
})
export class ValueBoxsService extends BaseCrudService<ICmsValueBox> {
  protected override getBaseUrl(): string {
    return `${environment.urlCms}/cms-value-boxs`;
  }
}